// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"435":"2170a7c0","618":"a88efb71","902":"0d1d36be"}[chunkId] + ".chunk.css";
};